import React from 'react';
import PropTypes from 'prop-types';
import theme from '../OverlayTheme.css';

const AdBlock = (props = {}) => {
  const { background } = props;
  return (
    <div className={theme.container}>
      <img className={theme.background} src={background} alt="" />
      <div className={theme.messageContainer}>
        <div className={theme.title}>Playback Error Message</div>
        <div className={theme.message}>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
          ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.
        </div>
      </div>
    </div>
  );
};

AdBlock.defaultProps = {
  background: '',
};

AdBlock.propTypes = {
  background: PropTypes.string,
};

export default AdBlock;
